;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	var Instance = APP.module('instance');
	View.LoginForm = Marionette.ItemView.extend({
		tagName: 'div',
		template: JST.LoginForm,
		ui: {
			email: '#email',
			password: '#password',
			name: '#name',
			loginForm: '#js-login-form',
			login: '#login-submit',
			loginAFLWTipping: '#login-submit-aflw-tipping',
			facebookLogin: '#facebook-login',
			setPasswordModal: '#js-send-recovery-email',
			errorContainer: '.error-message',
			ad_place: '.js-promo-widget',
		},
		events: {
			'click @ui.login': 'login',
			'click @ui.loginAFLWTipping': 'loginAFLWTipping',
			'submit @ui.loginForm': 'login',
			'click @ui.facebookLogin': 'facebookLogin',
			'click @ui.setPasswordModal': 'setPasswordModal',
			"keyup": "keyPressEventHandler"
		},


		initialize: function () {
			console.log("config", CONFIG);
			this.front_host = CONFIG.FRONT_HOST;
			this.model.set('front_host', CONFIG.FRONT_HOST);
			this.model.set('off_season', CONFIG.OFF_SEASON);

			var device_info = new MobileDetect(window.navigator.userAgent);
			this.is_mobile = Boolean(device_info.mobile());

			this.initViewOptions()
				.setModelData()
				.initViewListeners();

			this.trackAnalytics();
		},
		trackAnalytics() {
			return this;
		},
		trackLogin() {
			return this;
		},
		keyPressEventHandler: function (event) {
			if (event.keyCode == 13) {
				this.login(event);
			}
		},

		initViewOptions: function () {
			this.fbModel = this.options.facebookModel;
			this.fbconnect = this.options.facebookConnect;
			this.game = this.options.game;
			this.off_season = CONFIG.OFF_SEASON;
			this.builderOpt = this.options.builderOpt;

			return this;
		},

		initViewListeners: function () {

			this.initMRECFunctions();
			this.listenTo(APP.vent, 'user:preregistration', this.showPreregistrationConfirmation.bind(this));
			this.listenTo(this.fbconnect, 'facebook:error', function (error) {
				this.showErrors([{text: error.text}])
			});

			this.listenTo(this.fbconnect, 'facebook:connect:success', function () {
				this.fbModel.set('token', this.fbconnect.get('token'));
				this.loginWithToken();
			});

			return this;
		},

		initMRECFunctions: function () {
			if (APP.MREC_EXTENDS) {
				_.extend(this, APP.MREC_EXTENDS);
				this.initMREC(['promo'])
			}

			return this;
		},

		onRender() {
			console.log(this)
		},

		showPreregistrationConfirmation: function (response) {
			APP.vent.trigger('popup:message:show', 'Thank you for pre-registering your interest in the 2017 season');
		},
		setModelData: function () {
			this.model.set({
				game: this.game,
				front_host: this.front_host,
				is_mobile: this.is_mobile,
				builder_opt: this.builderOpt,
				is_login_disabled: CONFIG.IS_PRELAUNCH && APP.getJStorage('PreLaunchTrick') !== true, //HotFix for EUR-406
				season: CONFIG.SEASON
			});
			Backbone.history.navigate('login', {trigger: false});
			return this;
		},

		login: function (event) {
			event.preventDefault();

			if (!this.off_season && (!$(this.ui.email).val() || !$(this.ui.password).val())) {
				return;
			}

			this.showPreloader();

			$(this.ui.errorContainer).html('');

			var request = this.getRequestData();

			APP.setJStorage('session_id', '');
			APP.setJStorage('User', '');

			this.model.set('sid', '');

			$.when
				.call(null, this.model[request](this.model.toJSON()))
				.done(_.partial(this.loginResponseProcessor.bind(this), _, request));

			return this;
		},

		loginAFLWTipping: function (event) {
			event.preventDefault();

			function dec2hex(dec) {
				return ("0" + dec.toString(16)).substr(-2);
				}

			function generateRandomString() {
				var array = new Uint32Array(56 / 2);
				window.crypto.getRandomValues(array);
				return Array.from(array, dec2hex).join("");
			}

			function sha256(plain) {
				// returns promise ArrayBuffer
				const encoder = new TextEncoder();
				const data = encoder.encode(plain);
				return window.crypto.subtle.digest("SHA-256", data);
			}

			function base64urlencode(a) {
				var str = "";
				var bytes = new Uint8Array(a);
				var len = bytes.byteLength;
				for (var i = 0; i < len; i++) {
					str += String.fromCharCode(bytes[i]);
				}
				return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
			}

			function challenge_from_verifier(v) {
				return sha256(v).then((hashed) => base64urlencode(hashed));
			}

			var redirect_uri = `${CONFIG.ABSPATH}callback.html`;
			var	client_id = CONFIG.AFL_ID_CLIENT_ID;
			var verifier = generateRandomString();
			localStorage.setItem("code_verifier", verifier);
			localStorage.setItem("client_id", CONFIG.AFL_ID_CLIENT_ID);
			localStorage.setItem("redirect_uri", `${CONFIG.ABSPATH}callback.html`);
			var nonce = generateRandomString();
			var myState = generateRandomString();
			var code_challenge;

			challenge_from_verifier(verifier).then((res) => {
				code_challenge = res;
				// console.log(111, "pkce-challenge");
				// localStorage.setItem("222", code_challenge);
				// localStorage.setItem("999", `https://id.test.afl/oauth2/v1/authorize?
				// 	scope=openid email profile
				// 	&response_type=code
				// 	&redirect_uri=${redirect_uri}
				// 	&state=${myState}
				// 	&nonce=${nonce}
				// 	&client_id=${client_id}
				// 	&code_challenge=${code_challenge}
				// 	&code_challenge_method=S256`);
				const link = CONFIG.ENVIRONMENT === 'production' ? 'login.id.afl' : 'id.test.afl';

				window.location.href = `https://${link}/oauth2/v1/authorize?
					scope=openid email profile
					&response_type=code
					&redirect_uri=${redirect_uri}
					&state=${myState}
					&nonce=${nonce}
					&client_id=${client_id}
					&code_challenge=${code_challenge}
					&code_challenge_method=S256`
			  });
		},

		loginResponseProcessor: function (response, request) {
			if (response.errors.length) {
				var error = this.getEmailErrorTextAndButton(response.errors);

				if (error) {
					$(this.ui.errorContainer).append(error.text + error.button);
				}

			} else {

				APP.vent.trigger('user:' + request, response.result);

				this.trackLogin();
			}


			this.hidePreloader();
		},

		getRequestData: function () {

			if (this.off_season) {
				this.model.set('email', $(this.ui.email).val());
				this.model.set('first_name', $(this.ui.name).val());

				return 'preregistration';
			}

			this.model.set('login', $(this.ui.email).val());
			this.model.set('password', $(this.ui.password).val());

			return 'login';
		},

		facebookLogin: function (event) {
			event.preventDefault();
			this.showPreloader();
			this.initFaceBookConnect();
		},

		initFaceBookConnect: function () {
			this.fbconnect.initFacebookConnect();
		},

		loginWithToken: function () {

			APP.clearUser();
			this.model.set('sid', '');

			$.when(this.fbModel.save())
				.done(_.bind(function (response) {

					if (response.errors.length) {

						this.checkFbErrors(response);

					} else {
						APP.vent.trigger('user:login', response.result);
					}

				}, this));
		},
		checkFbErrors: function (response) {
			switch (response.errors[0].code) {
				case 403:
					APP.vent.trigger('registration_auto_fb_connect');
					Backbone.history.navigate('registration', {trigger: true});
					break;
				default:
					this.showErrors(response.errors);
					break;
			}
		},
		getEmailErrorTextAndButton: function (error) {
			var response = {};

			switch (error[0].code) {
				case 516:
					response.text = error[0].text;
					response.button = '<a href="javascript:void(0);" class="btn base-button" id="js-send-recovery-email">Set password  &rsaquo;</a>';
					break;
				default:
					this.showErrors(error);
					response = false;
					break
			}
			return response;
		},
		setPasswordModal: function () {

			var email = {email: this.model.get('login')};
			this.model.setApiUrl('password_recovery/send_token');
			this.showPreloader();
			this.model.save(null, {data: email, ajaxSync: true, success: _.bind(this.successPassRecovery, this)});
		},

		successPassRecovery: function (model, response) {

			var elem = $(this.ui.errorContainer);

			if (response.errors.length) {
				this.showErrors(response.errors);
			} else {

				this.model.set('login', '');
				this.model.setApiUrl('');
				$(this.ui.errorContainer).html('');

				Backbone.history.navigate('recovery-token-confirm', {trigger: true});

				this.hidePreloader();
			}
		},
	});

}(window, APP, Backbone, Marionette, $, _));